(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var GA = 'linear-gradient(135deg,#FFB36B,#FF5F8F 55%,#6B5BFF)', GB = 'linear-gradient(135deg,#7DD3FC,#6B5BFF)', GC = 'linear-gradient(135deg,#A7F3D0,#16A34A)', GD = 'linear-gradient(135deg,#FDE68A,#F97316)';
  var CK = "<svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#fff' stroke-width='3' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M20 6 9 17l-5-5'/></svg>";
  var WARN = "<svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#fff' stroke-width='3' stroke-linecap='round' aria-hidden='true'><path d='M12 7v6'/><path d='M12 17h.01'/></svg>";
  function once(el){ if(el.dataset.on) return false; el.dataset.on = '1'; return true; }
  function kr(v){ return Math.round(v).toLocaleString('sv-SE') + ' kr'; }
  function dec(v, d){ return v.toFixed(d).replace('.', ','); }
  function bump(el, c){ if(reduce || !el) return; el.classList.remove(c); void el.offsetWidth; el.classList.add(c); }
  function stopper(el){ var s = { v: false }; ['pointerdown','keydown','focusin'].forEach(function(e){ el.addEventListener(e, function(ev){ if(ev.isTrusted) s.v = true; }); }); return s; }
  function seen(el){
    var s = { v: true };
    if('IntersectionObserver' in window){ s.v = false; new IntersectionObserver(function(es){ es.forEach(function(e){ s.v = e.isIntersecting; }); }, { rootMargin: '80px' }).observe(el); }
    return s;
  }
  function live(el, st){ var s = seen(el); return function(){ return !st.v && s.v && !document.hidden; }; }
  // steps: [fn, ms]; fn may return a number to override the wait. Pauses (without advancing) when off screen.
  function play(el, st, steps, first){
    var ok = live(el, st), i = 0;
    function next(){
      if(st.v) return;
      if(!ok()){ setTimeout(next, 500); return; }
      var s = steps[i]; i = (i + 1) % steps.length;
      var r = s[0]();
      setTimeout(next, typeof r === 'number' ? r : s[1]);
    }
    setTimeout(next, first || 900);
  }
  function typeInto(inp, text, st, speed, cb){
    var k = 1; speed = speed || 65;
    (function t(){
      if(st && st.v) return;
      inp.value = text.slice(0, k);
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      if(k++ < text.length) setTimeout(t, speed); else if(cb) cb();
    })();
    return text.length * speed + 350;
  }
  function el(tag, cls, txt){ var e = document.createElement(tag); if(cls) e.className = cls; if(txt != null) e.textContent = txt; return e; }

  function quiz(q){
    var panes = q.querySelectorAll('.skd4-q'), bar = q.querySelector('[data-bar]'), step = q.querySelector('[data-step]'), why = q.querySelector('[data-why]'), st = stopper(q), cur = 0, picks = [];
    var labels = ['Fråga 1 av 2', 'Fråga 2 av 2', 'Ditt resultat'];
    function show(n){
      cur = n;
      panes.forEach(function(p, i){ p.classList.toggle('is-on', i === n); p.classList.toggle('is-past', i < n); });
      bar.style.width = [33, 66, 100][n] + '%';
      step.textContent = labels[n];
      if(n === 2){ why.innerHTML = ''; picks.forEach(function(p){ if(p) why.appendChild(el('span', 'skd-chip', p)); }); }
    }
    function pick(b){
      var p = b.closest('.skd4-q'), idx = Array.prototype.indexOf.call(panes, p);
      p.querySelectorAll('button').forEach(function(x){ x.classList.toggle('is-pick', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      picks[idx] = b.getAttribute('data-a');
    }
    function reset(){ picks = []; q.querySelectorAll('.skd4-ans button').forEach(function(b){ b.classList.remove('is-pick'); b.setAttribute('aria-pressed', 'false'); }); show(0); }
    q.querySelectorAll('.skd4-ans button').forEach(function(b){
      b.addEventListener('click', function(){ var n = cur; pick(b); setTimeout(function(){ if(cur === n && n < 2) show(n + 1); }, 420); });
    });
    q.querySelector('[data-redo]').addEventListener('click', reset);
    reset();
    if(reduce){ pick(panes[0].querySelectorAll('.skd4-ans button')[1]); return; }
    var a = 0;
    play(q, st, [
      [function(){ reset(); }, 1200],
      [function(){ pick(panes[0].querySelectorAll('.skd4-ans button')[(a + 1) % 3]); }, 700],
      [function(){ show(1); }, 1300],
      [function(){ pick(panes[1].querySelectorAll('.skd4-ans button')[(a + 2) % 3]); }, 700],
      [function(){ show(2); a++; }, 3600]
    ]);
  }

  function look(l){
    var dots = l.querySelectorAll('.skd4-dot'), pops = l.querySelectorAll('.skd4-pop'), st = stopper(l);
    function open(n){
      dots.forEach(function(d, i){ d.setAttribute('aria-expanded', i === n ? 'true' : 'false'); });
      pops.forEach(function(p, i){ p.classList.toggle('is-on', i === n); });
    }
    dots.forEach(function(d, i){ d.addEventListener('click', function(){ open(d.getAttribute('aria-expanded') === 'true' ? -1 : i); }); });
    l.querySelectorAll('[data-add]').forEach(function(b){
      var t = b.textContent, tm;
      b.addEventListener('click', function(){ b.textContent = 'Tillagd ✓'; clearTimeout(tm); tm = setTimeout(function(){ b.textContent = t; }, 1600); });
    });
    l.addEventListener('keydown', function(e){ if(e.key === 'Escape') open(-1); });
    if(reduce){ open(0); return; }
    play(l, st, [
      [function(){ open(0); }, 2400],
      [function(){ open(1); }, 2400],
      [function(){ open(2); }, 2400],
      [function(){ open(-1); }, 900]
    ], 700);
  }

  function spin(s){
    var stage = s.querySelector('.skd4-spin__stage'), strip = s.querySelector('[data-strip]'), cap = s.querySelector('.skd4-bottle__cap'), degEl = s.querySelector('[data-deg]'), arc = s.querySelector('[data-arc]'), frames = s.querySelectorAll('.skd4-spin__frames i'), hint = s.querySelector('.skd4-spin__hint'), st = stopper(s), deg = 0, C = 56.55, drag = null;
    function set(d){
      deg = ((d % 360) + 360) % 360;
      var f = deg / 360, r = Math.round(deg) % 360, fr = Math.floor(deg / 30) % 12;
      strip.style.transform = 'translateX(' + (-f * 50).toFixed(3) + '%)';
      cap.style.setProperty('--cap', (-f * 120).toFixed(1) + 'px');
      degEl.textContent = r + '°';
      arc.style.strokeDashoffset = (C * (1 - f)).toFixed(2);
      frames.forEach(function(x, i){ x.classList.toggle('is-on', i === fr); });
      stage.setAttribute('aria-valuenow', r);
    }
    stage.addEventListener('pointerdown', function(e){
      if(!e.isPrimary) return;
      drag = { x: e.clientX, d: deg }; stage.classList.add('is-drag'); if(hint) hint.classList.add('is-off');
      try{ stage.setPointerCapture(e.pointerId); }catch(_){}
    });
    stage.addEventListener('pointermove', function(e){ if(drag) set(drag.d - (e.clientX - drag.x) * 0.9); });
    function end(){ drag = null; stage.classList.remove('is-drag'); }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    stage.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight' || e.key === 'ArrowUp'){ set(deg + 15); e.preventDefault(); }
      else if(e.key === 'ArrowLeft' || e.key === 'ArrowDown'){ set(deg - 15); e.preventDefault(); }
      else if(e.key === 'Home'){ set(0); e.preventDefault(); }
    });
    set(342);
    if(reduce) return;
    var ok = live(s, st), last = 0;
    function tick(t){
      if(st.v) return;
      if(!ok()){ last = 0; setTimeout(function(){ requestAnimationFrame(tick); }, 500); return; }
      if(last) set(deg + Math.min(64, t - last) * 0.055);
      last = t; requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function wish(w){
    var hearts = w.querySelectorAll('.skd4-heart'), cnt = w.querySelector('[data-count]'), openBtn = w.querySelector('[data-open]'), list = w.querySelector('[data-list]'), st = stopper(w);
    function render(){
      list.innerHTML = ''; var n = 0;
      hearts.forEach(function(h){
        if(h.getAttribute('aria-pressed') !== 'true') return;
        n++;
        var c = h.closest('.skd4-pc'), it = el('div', 'skd4-wl__item'), th = el('span', 'skd4-thumb'), tx = el('div');
        th.style.background = c.getAttribute('data-bg'); tx.style.flex = '1'; tx.style.minWidth = '0';
        tx.appendChild(el('b', '', c.getAttribute('data-name'))); tx.appendChild(el('span', '', c.getAttribute('data-price')));
        it.appendChild(th); it.appendChild(tx); list.appendChild(it);
      });
      cnt.textContent = n; openBtn.classList.toggle('has', n > 0);
    }
    function set(h, on, quiet){
      var name = h.closest('.skd4-pc').getAttribute('data-name');
      h.setAttribute('aria-pressed', on ? 'true' : 'false');
      h.setAttribute('aria-label', on ? 'Ta bort ' + name + ' från önskelistan' : 'Spara ' + name + ' i önskelistan');
      if(!quiet){ if(on) bump(h, 'pop'); bump(openBtn, 'bump'); }
      render();
    }
    function drawer(o){ w.classList.toggle('is-open', o); openBtn.setAttribute('aria-expanded', o ? 'true' : 'false'); }
    hearts.forEach(function(h){ h.addEventListener('click', function(){ set(h, h.getAttribute('aria-pressed') !== 'true'); }); });
    openBtn.addEventListener('click', function(){ drawer(true); });
    w.querySelectorAll('[data-close]').forEach(function(c){ c.addEventListener('click', function(){ drawer(false); }); });
    w.addEventListener('keydown', function(e){ if(e.key === 'Escape') drawer(false); });
    render();
    if(reduce){ set(hearts[0], true, true); return; }
    play(w, st, [
      [function(){ drawer(false); hearts.forEach(function(h){ set(h, false, true); }); }, 1300],
      [function(){ set(hearts[0], true); }, 1400],
      [function(){ drawer(true); }, 2800],
      [function(){ drawer(false); }, 900]
    ], 600);
  }

  var POOL = [['Tröja', '399 kr', GA], ['Väska', '649 kr', GB], ['Mössa', '199 kr', GC], ['Sneakers', '899 kr', GD], ['Klocka', '1 299 kr', 'linear-gradient(135deg,#F9A8D4,#6B5BFF)'], ['Solglasögon', '349 kr', 'linear-gradient(135deg,#C4B5FD,#17171C)']];
  function recent(r){
    var row = r.querySelector('[data-row]'), st = stopper(r), items = [], k = 0;
    function card(it, cls, first){
      var b = el('button', 'skd4-rc' + (cls ? ' ' + cls : '')), im = el('span', 'skd4-rc__img');
      b.type = 'button'; im.style.background = it[2]; if(first) im.appendChild(el('i', '', 'Nyss'));
      b.appendChild(im); b.appendChild(el('small', '', it[0])); b.appendChild(el('b', '', 'Exempelprodukt')); b.appendChild(el('span', '', it[1]));
      b.addEventListener('click', function(){ var i = items.indexOf(it); if(i > 0){ items.splice(i, 1); items.unshift(it); render(true); } });
      return b;
    }
    function ghost(){
      var b = el('div', 'skd4-rc skd4-rc--ghost'); b.setAttribute('aria-hidden', 'true');
      b.appendChild(el('span', 'skd4-rc__img')); b.appendChild(el('i', 'skd4-gl')); b.appendChild(el('i', 'skd4-gl'));
      return b;
    }
    function render(fresh){
      row.innerHTML = '';
      for(var i = 0; i < 4; i++){ row.appendChild(items[i] ? card(items[i], fresh ? (i === 0 ? 'is-new' : 'is-shift') : '', i === 0) : ghost()); }
    }
    function add(){ var it = POOL[k++ % POOL.length]; var i = items.indexOf(it); if(i > -1) items.splice(i, 1); items.unshift(it); if(items.length > 4) items.pop(); render(true); }
    r.querySelector('[data-clear]').addEventListener('click', function(){ items = []; render(false); });
    if(reduce){ items = POOL.slice(0, 4); render(false); return; }
    items = []; render(false);
    play(r, st, [
      [add, 950], [add, 950], [add, 950], [add, 2400],
      [add, 2800],
      [function(){ r.classList.add('is-clear'); }, 450],
      [function(){ items = []; render(false); r.classList.remove('is-clear'); }, 800]
    ], 700);
  }

  function watch(b){
    var sizes = b.querySelectorAll('[data-s]'), col = b.querySelector('.skd4-collapse'), form = b.querySelector('form'), mail = form.querySelector('input[type=email]'), ok = form.querySelector('input[type=checkbox]'), send = form.querySelector('[type=submit]'), err = form.querySelector('.skd4-bv__err'), st = stopper(b);
    function sel(s){
      sizes.forEach(function(x){ x.setAttribute('aria-pressed', x === s ? 'true' : 'false'); });
      var out = s.hasAttribute('data-out');
      b.classList.toggle('is-out', out); col.classList.toggle('is-open', out);
      if(!out) b.classList.remove('is-ok');
    }
    function reset(){ b.classList.remove('is-ok'); mail.value = ''; ok.checked = false; err.textContent = ''; sel(sizes[1]); }
    sizes.forEach(function(s){ s.addEventListener('click', function(){ sel(s); }); });
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail.value)){ err.textContent = 'Fyll i en giltig e-postadress.'; return; }
      if(!ok.checked){ err.textContent = 'Kryssa i rutan så att vi får mejla dig.'; return; }
      err.textContent = ''; b.classList.add('is-ok');
    });
    reset();
    if(reduce){ sel(sizes[2]); mail.value = 'anna@exempel.se'; ok.checked = true; return; }
    play(b, st, [
      [reset, 1300],
      [function(){ sel(sizes[2]); }, 1200],
      [function(){ return typeInto(mail, 'anna@exempel.se', st, 70); }, 0],
      [function(){ ok.checked = true; bump(ok.closest('label'), 'tick'); }, 800],
      [function(){ send.classList.add('is-press'); }, 300],
      [function(){ send.classList.remove('is-press'); b.classList.add('is-ok'); }, 3000]
    ]);
  }

  function gift(g){
    var GREET = 'Grattis på dagen! Hoppas den passar';
    var box = g.querySelector('[data-gift]'), tog = box.closest('label'), col = g.querySelector('[data-box]'), msg = g.querySelector('[data-msg]'), n = g.querySelector('[data-n]'), from = g.querySelector('[data-from]'), wrap = g.querySelector('[data-wrap]'), wl = g.querySelector('[data-wl]'), tot = g.querySelector('[data-total]'), saved = g.querySelector('[data-saved]'), st = stopper(g), base = 499, extra = 39, tm;
    function upd(){
      var on = box.checked, w = on && wrap.checked, v = kr(base + (w ? extra : 0));
      tog.classList.toggle('is-on', on); col.classList.toggle('is-open', on); wl.classList.toggle('is-open', w);
      if(tot.textContent !== v){ tot.textContent = v; bump(tot, 'tick'); }
      n.textContent = msg.value.length;
    }
    function save(){ saved.classList.remove('is-on'); clearTimeout(tm); tm = setTimeout(function(){ saved.classList.add('is-on'); }, 600); }
    [box, wrap].forEach(function(x){ x.addEventListener('change', function(){ upd(); save(); }); });
    [msg, from].forEach(function(x){ x.addEventListener('input', function(){ upd(); save(); }); });
    function reset(){ clearTimeout(tm); box.checked = false; wrap.checked = false; msg.value = ''; from.value = ''; saved.classList.remove('is-on'); upd(); }
    reset();
    if(reduce){ box.checked = true; msg.value = GREET; from.value = 'Anna'; wrap.checked = true; upd(); saved.classList.add('is-on'); return; }
    play(g, st, [
      [reset, 1200],
      [function(){ box.checked = true; upd(); }, 900],
      [function(){ return typeInto(msg, GREET, st, 55); }, 0],
      [function(){ return typeInto(from, 'Anna', st, 110); }, 0],
      [function(){ wrap.checked = true; upd(); save(); }, 3600]
    ]);
  }

  function calc(c){
    var L = c.querySelector('[data-l]'), W = c.querySelector('[data-w]'), sp = c.querySelectorAll('[data-sp]'), area = c.querySelector('[data-area]'), rolls = c.querySelector('[data-rolls]'), unit = c.querySelector('[data-unit]'), sum = c.querySelector('[data-sum]'), btn = c.querySelector('[data-add]');
    var cov = parseFloat(c.getAttribute('data-cov')) || 2.5, price = +c.getAttribute('data-price') || 499, st = stopper(c), spill = 10, shown = { a: 0, r: 0, s: 0 }, raf;
    function num(i){ var v = parseFloat(String(i.value).replace(',', '.').replace(/[^0-9.]/g, '')); return isFinite(v) && v > 0 ? Math.min(v, 999) : 0; }
    function draw(a, r, s){ area.textContent = dec(a, 1); rolls.textContent = r; unit.textContent = r === 1 ? 'rulle' : 'rullar'; sum.textContent = kr(s); }
    function run(anim){
      var a = num(L) * num(W) * (1 + spill / 100), r = a > 0 ? Math.ceil(a / cov - 1e-9) : 0, s = r * price, from = shown;
      btn.textContent = r > 0 ? 'Lägg ' + r + ' st i varukorgen' : 'Fyll i måtten';
      btn.disabled = r === 0;
      shown = { a: a, r: r, s: s };
      cancelAnimationFrame(raf);
      if(!anim || reduce){ draw(a, r, s); return; }
      var t0 = null;
      (function step(t){
        if(t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / 700), e = 1 - Math.pow(1 - p, 3);
        draw(from.a + (a - from.a) * e, Math.round(from.r + (r - from.r) * e), from.s + (s - from.s) * e);
        if(p < 1) raf = requestAnimationFrame(step);
      })(performance.now());
    }
    [L, W].forEach(function(i){ i.addEventListener('input', function(){ run(true); }); });
    sp.forEach(function(b){ b.addEventListener('click', function(){ spill = +b.getAttribute('data-sp'); sp.forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); run(true); }); });
    if(reduce){ run(false); return; }
    run(true);
    var sets = [['4,2', '1,5'], ['5,8', '1,5']], k = 0;
    function typ(){
      k = (k + 1) % sets.length; L.classList.add('is-typing');
      return typeInto(L, sets[k][0], st, 220, function(){ setTimeout(function(){ L.classList.remove('is-typing'); }, 300); });
    }
    play(c, st, [[typ, 0], [function(){}, 3200]], 3000);
  }

  var FIT = { 'BMW': { '3-serie': ['F30', 'G20'], '5-serie': ['G30'] }, 'Volvo': { 'XC60': ['Gen 2'], 'V60': ['Gen 2'] }, 'Audi': { 'A4': ['B9'] } };
  var FITS = ['BMW 3-serie F30', 'BMW 3-serie G20', 'Audi A4 B9'];
  function fits(f){
    var mk = f.querySelector('[data-l=make]'), md = f.querySelector('[data-l=model]'), gn = f.querySelector('[data-l=gen]'), res = f.querySelector('[data-res]'), txt = f.querySelector('[data-txt]'), ic = res.querySelector('.skd4-fit__ic'), st = stopper(f);
    function fill(sel, items){ sel.innerHTML = ''; sel.appendChild(new Option('Välj', '')); items.forEach(function(v){ sel.appendChild(new Option(v, v)); }); sel.disabled = !items.length; }
    function mark(){ [mk, md, gn].forEach(function(s){ s.classList.toggle('is-set', !!s.value); }); }
    function result(){
      res.classList.remove('is-ok', 'is-no'); ic.innerHTML = ''; txt.innerHTML = '';
      if(!gn.value){ txt.appendChild(el('span', '', 'Välj din bil för att se om delen passar.')); return; }
      void res.offsetWidth;
      var car = mk.value + ' ' + md.value + ' ' + gn.value;
      if(FITS.indexOf(car) > -1){
        res.classList.add('is-ok'); ic.innerHTML = CK;
        txt.appendChild(el('b', '', 'Passar din ' + car)); txt.appendChild(el('small', '', 'Enligt passningslistan för Exempelprodukt'));
      } else {
        res.classList.add('is-no'); ic.innerHTML = WARN;
        txt.appendChild(el('b', '', 'Vi hittar inte att den passar din ' + mk.value + ' ' + md.value));
        var a = el('button', 'skd4-link', 'Se delar för din bil →'); a.type = 'button'; txt.appendChild(a);
      }
    }
    function setMake(v){ mk.value = v; fill(md, v ? Object.keys(FIT[v]) : []); fill(gn, []); mark(); result(); }
    function setModel(v){ md.value = v; fill(gn, v ? FIT[mk.value][v] : []); mark(); result(); }
    function setGen(v){ gn.value = v; mark(); result(); }
    function flash(s){ if(reduce) return; s.classList.add('is-flash'); setTimeout(function(){ s.classList.remove('is-flash'); }, 500); }
    fill(mk, Object.keys(FIT));
    mk.addEventListener('change', function(){ setMake(mk.value); });
    md.addEventListener('change', function(){ setModel(md.value); });
    gn.addEventListener('change', function(){ setGen(gn.value); });
    if(reduce){ setMake('BMW'); setModel('3-serie'); setGen('F30'); return; }
    setMake('');
    var cars = [['BMW', '3-serie', 'F30'], ['Volvo', 'XC60', 'Gen 2']], k = 0;
    play(f, st, [
      [function(){ setMake(''); }, 900],
      [function(){ setMake(cars[k][0]); flash(mk); }, 750],
      [function(){ setModel(cars[k][1]); flash(md); }, 750],
      [function(){ setGen(cars[k][2]); flash(gn); k = (k + 1) % cars.length; }, 3300]
    ], 600);
  }

  var MAP = { '[data-skd4-quiz]': quiz, '[data-skd4-look]': look, '[data-skd4-spin]': spin, '[data-skd4-wl]': wish, '[data-skd4-rv]': recent, '[data-skd4-bv]': watch, '[data-skd4-gift]': gift, '[data-skd4-calc]': calc, '[data-skd4-fit]': fits };
  function init(root){
    Object.keys(MAP).forEach(function(sel){
      root.querySelectorAll(sel).forEach(function(x){ if(!once(x)) return; try{ MAP[sel](x); }catch(e){ if(window.console) console.warn('sektio-demo4', e); } });
    });
  }
  function boot(){ init(document); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
